import { useSelector } from 'react-redux';
import {
  isUserAnnotatorBetaSelector,
  isUserViewer,
} from '../../../redux/modules/user/selectors';

export const useCanManageCustomRelations = () => {
  const isLimitedAnnotator = useSelector(isUserAnnotatorBetaSelector);
  const isViewer = useSelector(isUserViewer);

  return !(isLimitedAnnotator || isViewer);
};
